import React from 'react';

import Page from 'sharedreact/components/Page';
import { Tab } from 'sharedreact/components/Sidebar';
import SidebarLayout from 'sharedreact/components/SidebarLayout';
import PageNotFound404ErrorContainer from 'sharedreact/containers/PageNotFound404ErrorContainer';
import { translate } from 'sharedreact/utils/LanguageSupport';

import HomeStatusbar from 'workspaces/launcher/components/HomeStatusbar';
import MainContainer from 'workspaces/launcher/containers/clientapps/MainContainer';
import ToolsContainer from 'workspaces/launcher/containers/clientapps/ToolsContainer';

type Props = {
  language: string,
  activeTab: string,

  onSelectTab: (tab: string) => void
};

class clientAppsPage extends React.Component<Props> {
  constructor (props: Props) {
    super(props);

    this.handleSelectTab = this.handleSelectTab.bind(this);
  }

  handleSelectTab (tabIndex: number): void {
    const tabNames: string[] = this.getTabNames();
    this.props.onSelectTab(tabNames[tabIndex] || '');
  }

  getTabNames (): string[] {
    return [ 'main', 'tools' ];
  }

  override render (): React.ReactNode {
    const { language, activeTab } = this.props;

    const tabs: Tab[] = [
      {id: 'ae_tab_clientapps_main', name: translate('launcher.clientapps.main.title')},
      {id: 'ae_tab_clientapps_tools', name: translate('launcher.clientapps.tools.title')}
    ];

    const tabNames: string[] = this.getTabNames();

    const activeIndex = tabNames.indexOf(activeTab || 'main');

    return (
      <Page className='webappslauncher-clientapps-page'>
        <SidebarLayout tabs={tabs}
          onSelectTab={this.handleSelectTab}
          activeTab={activeIndex}>
          <MainContainer index={tabNames.indexOf('main')} activeTab={activeIndex} />
          <ToolsContainer index={tabNames.indexOf('tools')} activeTab={activeIndex} />
          {activeIndex < 0 || activeIndex >= tabs.length
            ? <PageNotFound404ErrorContainer />
            : null
          }
        </SidebarLayout>
        <HomeStatusbar />
      </Page>
    );
  }
}

export default clientAppsPage;
